<template>
  <BModal v-model="isOpen" size="lg" centered hide-footer hide-header>
    <InvoiceSend/>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import InvoiceSend from './InvoiceSend';

export default {
  components: {
    BModal,
    InvoiceSend,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.invoices.isSendInvoiceModalOpen;
      },
      set(val) {
        this.$store.commit('invoices/isSendInvoiceModalOpen', val);
      },
    },
  },
};
</script>
